"use client";

import styled from "styled-components";

import Image from "../image";

interface BoxAlertProductProps {
  $isLowStock?: boolean;
}

export const CardService = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
  padding: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  transition: 0.4s;
  width: 100%;
  background: white;
  min-height: 280px;

  @media (max-width: 768px) {
    padding: 12px;
    gap: 15px;
    min-height: auto;
  }

  &:hover {
    box-shadow: var(--shadowHoverCard);
  }
`;

export const TopTheBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  padding-top: 15px;
`;

export const FirstBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const BoxImage = styled.div`
  width: 96px;
  height: 96px;
  margin: auto;
  position: relative;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    width: 80px;
    height: 80px;
    margin-bottom: 8px;
  }
`;

export const ImageEmployee = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: 100px;
  object-fit: cover;

  &.cursor-pointer {
    cursor: pointer;
  }
`;

export const AvatarPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  font-size: 32px;
  font-family: "Inter Medium", sans-serif;
  user-select: none;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  &.cursor-pointer {
    cursor: pointer;
    transition:
      transform 0.2s,
      box-shadow 0.2s;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  flex-wrap: nowrap;
  width: 100%;
`;

export const BoxIcon = styled.div`
  background: var(--softMint);
  border-radius: 5px;
  padding: 5px;
  svg {
    width: 18px;
    height: 18px;
    path {
      stroke: var(--greenAndWhite);
    }
    circle {
      stroke: var(--greenAndWhite);
    }
  }
`;

export const TitleCard = styled.h3`
  font-family: "Inter Medium";
  font-size: 17px;
  color: var(--colorTitle);
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const TitleDescription = styled.h4`
  font-family: "Inter Medium";
  font-size: 15px;
  color: var(--textLight);
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const BodyCard = styled.div`
  width: 100%;
  text-align: left;
`;

export const FooterCard = styled.div`
  border-top: 1px solid var(--border);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
  padding-top: 15px;

  button {
    width: 100%;
  }

  @media (min-width: 768px) {
    flex-direction: row;

    button {
      width: fit-content;
    }
  }
`;

export const TextDescription = styled.p`
  font-family: "Inter Regular";
  color: var(--textLight);
  font-size: 15px;
`;

export const BoxAlertProduct = styled.div<BoxAlertProductProps>`
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 50px;
  background-color: ${({ $isLowStock }) =>
    $isLowStock ? "#ffe5e5" : `var(--primarySystem)`};
  color: ${({ $isLowStock }) =>
    $isLowStock ? "#ff4d4f" : `var(--primarySystem100)`};
  position: absolute;
  right: -5px;
  top: -20px;
`;

export const ScoreStar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Inter Regular";
  font-size: 15px;
  color: var(--textLight);
  gap: 3px;
  width: 100%;

  svg {
    width: 15px;
    height: 15px;
    stroke: var(--infoSystem);
    fill: var(--infoSystem);
    margin-top: -2px;
  }
`;

export const BoxButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const ListItemEMployees = styled.ul`
  padding: 0;
  margin: 0;
`;

export const ItemEmployee = styled.li`
  display: flex;
  align-items: center;
  font-family: "Inter Regular";
  font-size: 14px;
  color: var(--textLight);
  gap: 5px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    width: 15px;
    height: 15px;
  }
`;

/* New styles for list (row) layout */
export const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid var(--border);
`;

export const RowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 220px;
`;

export const RowMiddle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RowRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 240px;
  justify-content: flex-end;
`;

export const SmallControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 16px;

  label {
    font-size: 13px;
    line-height: 16px;
    padding-left: 24px;
  }

  input[type="checkbox"] + label:before {
    width: 16px;
    height: 16px;
  }

  input[type="checkbox"] + label:after {
    width: 16px;
    height: 16px;
    font-size: 12px;
    line-height: 16px;
  }
`;

export const SmallLabel = styled.span`
  font-size: 13px;
  color: var(--textLight);
`;
